import { RefreshCw } from 'lucide-react';
import { Button } from './charte';
import { useNewVersionAvailable } from '../lib/appUpdate';

/**
 * Bandeau « nouvelle version » : l'application restée ouverte (ou remise au premier plan) pendant
 * une livraison propose de se recharger. Pas de rechargement d'office : une saisie en cours serait
 * perdue.
 */
export default function UpdateAppBanner() {
  const available = useNewVersionAvailable();
  if (!available) return null;

  return (
    <div className="border-b border-primary-100 bg-surface-indigo" role="status">
      <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-2.5 sm:px-6">
        <span className="grid h-8 w-8 shrink-0 place-items-center rounded-xl bg-white text-primary shadow-sm">
          <RefreshCw size={16} aria-hidden />
        </span>
        <p className="min-w-0 flex-1 text-sm font-medium text-body">Une nouvelle version de Permio est disponible</p>
        <Button variant="primary" size="sm" onClick={() => window.location.reload()}>
          Mettre à jour
        </Button>
      </div>
    </div>
  );
}
